export default __webpack_public_path__ + "static/media/cart.4018b035.svg";